import React from "react";

function CommonInputContainer({
  children,
  label,
  className = "flex-1",
  error,
}) {
  return (
    <div className={`flex flex-shrink-0 flex-col w-full text-sm ${className}`}>
      {label && (
        <span
          className={`block text-sm mb-1 ${
            error ? "text-red-600" : "text-gray-600"
          }`}
        >
          {label}
        </span>
      )}
      {children}
    </div>
  );
}

export default CommonInputContainer;
